import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { MngIconService } from '@mng/mng-icon';
import { MngThemeService } from '@mng/mng-theme';
import {
  AuthService,
  AuthStateFacade,
  KIDS_BUCHUNG_PATH,
  MgsActiveState,
  MgsNavContainerComponent,
  MgsRoutingService
} from '@mng/mgs-ui';
import { IFrameHandler, MngFrameComponent } from '@mng/mng-frame';
import { MngDialogService } from '@mng/mng-inputs';
import { Router } from '@angular/router';
import { MngNavDialogService } from '@mng/mng-base-ui';

export interface ExternalRoute {
  url: string;
  target: '_self' | '_blank';
}

const kidsReservierungPath = `/${KIDS_BUCHUNG_PATH}`;

@Component({
  selector: 'mng-mgs-app-root',
  imports: [MngFrameComponent, MgsNavContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class AppComponent {
  frameHandler: IFrameHandler;

  appRootPath = () =>
    this.isKidsReservierungPath() || this.authStateFacade.isKidsTerminUser() ? `/${KIDS_BUCHUNG_PATH}` : '/';

  appUserPath = () =>
    this.isKidsReservierungPath() || this.authStateFacade.isKidsTerminUser() ? `/${KIDS_BUCHUNG_PATH}` : 'user';

  isKidsReservierungPath = () => this.router.url.startsWith(kidsReservierungPath);

  constructor(
    iconService: MngIconService,
    themeService: MngThemeService,
    public activeState: MgsActiveState,
    dialogService: MngDialogService,
    authService: AuthService,
    public authStateFacade: AuthStateFacade,
    public router: Router,
    defaultRoutingService: MgsRoutingService,
    private navDialogService: MngNavDialogService
  ) {
    this.frameHandler = {
      registerAction: () =>
        dialogService.showOK({
          htmlContent: `Registrierung ist hier nicht möglich <br> Bitte wenden Sie sich an Ihren Ansprechpartner`
        }),
      logoutAction: async (frame: MngFrameComponent) => {
        const routeAfterLogout = this.appRootPath();
        await authService.logout();
        frame.navigateToRoute([routeAfterLogout]);
      },
      loginAction: (frame: MngFrameComponent) => frame.navigateToRoute([this.appRootPath()]),
      benutzerEinstellungenAction: (frame: MngFrameComponent) => this.navigateTo(frame, [this.appUserPath()]),
      navigateHomeAction: (frame: MngFrameComponent) => this.navigateTo(frame, [this.appRootPath()])
    };

    themeService.initializeTheme();
    themeService.darkMode = false;
    iconService.initializeIcons();
    activeState.initialize();
    defaultRoutingService.initialize();
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === 'F12' && this.authStateFacade.authenticated()) {
      this.navDialogService.openNavDialog({
        actionDefs: this.activeState.actionDefs(),
        userId: this.authStateFacade.user().userId
      });
    }
  }

  async navigateTo(frame: MngFrameComponent, route: string[]) {
    // Potentielles "canDeactivate" handling für aktive "components" vor dem aufruf von "externen" routes die sich nicht im angular ecosystem befinden
    // (ansonsten "guard" handling)
    frame.navigateToRoute(route);
  }
}
